export const COLUMN_MIN_WIDTH = 48;
export const COLUMN_MIN_HEIGHT = 48;
export const EXPAND_COLUMN_WIDTH = 52;
export const SCROLL_MAX_HEIGHT = 600;
